import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiQueryHook } from '../../../../common/queryClient/createApiQueryHook';
import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import { AlgorithmTargetsFormDataSchema } from '../schema/AlgorithmTargetsFormDataSchema';
import { AlgorithmTargetsFormDataType } from '../schema/types';

interface AlgorithmTargetsQueryParams {
  id: number;
}

const getAlgorithmTargets = (params?: AlgorithmTargetsQueryParams) =>
  apiClient
    .get<AlgorithmTargetsFormDataType>(expand(AlgorithmUrl.TARGETS, params))
    .then((response) => AlgorithmTargetsFormDataSchema.parse(response.data));

export const useGetAlgorithmTargetsQuery = createApiQueryHook(
  ['algorithm-targets'],
  getAlgorithmTargets
);
